document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');

  if (menuButton && menu) {
    menuButton.addEventListener('click', function () {
      const isOpen = menu.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.classList.remove('open');
        menuButton.setAttribute('aria-expanded', 'false');
      });
    });
  }

  const filters = document.querySelectorAll('[data-filter]');
  const cards = document.querySelectorAll('[data-product-grid] [data-category]');

  filters.forEach(function (button) {
    button.addEventListener('click', function () {
      const category = button.getAttribute('data-filter');
      filters.forEach(function (item) { item.classList.remove('active'); });
      button.classList.add('active');
      cards.forEach(function (card) {
        const cardCategories = card.getAttribute('data-category').trim().split(/\s+/);
        card.hidden = category !== 'all' && !cardCategories.includes(category);
      });
    });
  });
});
